import { action, type Action } from 'easy-peasy';

interface GlobalUtilsState {
  pageTitle: string;
}

export interface GlobalUtilsModel extends GlobalUtilsState {
  updatePageTitle: Action<GlobalUtilsModel, string | undefined>;
}

const defaultState: GlobalUtilsState = {
  pageTitle: '',
};

const model: GlobalUtilsModel = {
  ...defaultState,

  updatePageTitle: action((state: GlobalUtilsState, payload?: string) => {
    return {
      ...state,
      pageTitle: payload ?? '',
    };
  }),
};

export default model;
